module.exports = __webpack_public_path__ + "static/media/17.3cc1c428.jpg";